// Strict no em-dash policy. Use colons, periods, commas only.
export const translations = {
  en: {
    nav: {
      home: "Home",
      capabilities: "Solutions",
      sectors: "Sectors",
      about: "About",
      contact: "Contact",
      cta: "Initiate Consultation",
    },
    common: {
      lang: "EN",
      explore: "Explore",
      readMore: "Continue",
      back: "Return",
      since: "Established Benchmark : Two Decades",
      locations: "Los Angeles. Rio de Janeiro.",
    },
    home: {
      eyebrow: "Strategic Expertise. Institutional Precision.",
      heroTitle: "Strategic Expertise in the | Brazilian Middle Market.",
      heroSub: "Eliminating friction. Securing valuation. Executing entry.",
      heroCta: "Strategic Consultation",
      heroSecondary: "Review Solutions",

      quoteText:
        "We understand both the operational realities of South American business and the expectations of North American institutional investors.",

      // Carousel slides
      slide1Eyebrow: "Strategic Expertise. Institutional Precision.",
      slide1Title: "Strategic Expertise in the | Brazilian Middle Market.",
      slide1Sub:
        "Direct and exclusive origination reach across Brazil's largest middle market opportunities.",

      slide3Eyebrow: "The Bridge. Capital to Energy.",
      slide3Title: "Where Global Capital Meets | Brazilian Energy.",
      slide3Sub:
        "Nivne unlocks Brazil's most valuable assets before they reach the market.",

      slide4Eyebrow: "Originator. Finder. Institutional Advisory.",
      slide4Title: "We Don't Wait for Deals. || We Build Them.",
      slide4Sub:
        "Where institutional capital meets the people who actually find the opportunity.",
      slide4CtaPrimary: "Strategic Consultation",
      slide4CtaSecondary: "Our Approach",

      slide5Eyebrow: "Oil & Gas. Mining. Agribusiness. Commodities.",
      slide5Title: "Brazil Runs Deep. || So Does Our Access.",
      slide5Sub:
        "From pre salt basins to agribusiness heartlands. Brazil's full resource depth, originated by us.",
      slide5CtaPrimary: "Explore Sectors",
      slide5CtaSecondary: "Real Assets",

      slide6Eyebrow: "Clean Energy. Renewables. Infrastructure.",
      slide6Title: "The Future Is Being Built. | We Know Exactly Where.",
      slide6Sub:
        "Solar, wind, green hydrogen. Latin America's energy matrix is being rewritten.",
      slide6SubItalic: "We're already at the table.",
      slide6CtaPrimary: "Energy Transition",
      slide6CtaSecondary: "Our Mandates",
      stripStat1Value: "500M+",
      stripStat1Label: "Reais in Direct M&A Exposure",
      stripStat2Value: "20",
      stripStat2Label: "Year Technical Benchmark",
      stripStat3Value: "Middle",
      stripStat3Label: "Market Specialization",
      stripStat4Value: "LA. Rio.",
      stripStat4Label: "Operational Coverage",

      solutionsEyebrow: "Strategic Solutions",
      solutionsTitle: "We architect the path for | international capital.",
      solutionsBody:
        "Our approach is purely technical, removing the guesswork from cross-border deployment into the Brazilian emergent market.",

      f1Title: "Deal Origination",
      f1Body:
        "The primary originator of exclusive, off-market deal flow in the Brazilian middle market.",
      f2Title: "M&A Advisory",
      f2Body:
        "Identifying and securing off-market targets with precision. We control the lifecycle from origination to close.",
      f3Title: "Market Entry Strategy",
      f3Body:
        "Tailored roadmaps for sustainable institutional presence. Engineered around regulatory and operational reality.",

      whyEyebrow: "Excellence in Detail",
      whyTitle: "A taste of | our difference.",
      why1Title: "Origination Authority",
      why1Body:
        "Mandates that never reach a public auction. Our network of operators, family offices, and tier-one founders surfaces middle-market opportunities before the rest of the market knows they exist.",
      why2Title: "Federation of Industries Access",
      why2Body:
        "Direct relationships with Brazil's second-largest federation of industries. Visibility into thousands of operating assets across regulated sectors. Where outsiders see noise, we read the signal.",
      why3Title: "Multidisciplinary Analysis",
      why3Body:
        "Every transaction is read through legal, financial, regulatory, and operational lenses at the same time. Cross border capital deserves more than a single discipline thesis. It requires institutional triangulation.",
      whyQuote:
        "In private equity, the deal is won before the term sheet is signed.",

      ctaEyebrow: "Executive Engagement",
      ctaTitle:
        "Partner with the definitive reference for the | Brazilian middle market.",
      ctaButton: "Strategic Consultation",
    },
    capabilities: {
      eyebrow: "Deep technical value. Absolute origination.",
      title: "The | Strategic Edge",
      subtitle:
        "Three integrated mandates, one institutional discipline. The definitive gateway to the Brazilian middle market.",
      block1Roman: "I.",
      block1Title: "Proprietary Deal Origination",
      block1Body:
        "The definitive source for off-market alpha. We act as the primary originator for institutional mandates, utilizing deep-rooted Ground Truth to identify assets before they reach the open market. Our protocols focus on exclusive deal flow, ensuring our partners bypass the friction of traditional brokerage to secure high-value entry points.",
      block1Items: [
        "Off-market origination protocols.",
        "Proprietary deal-flow sourcing.",
        "Direct-to-Founder engagement.",
        "Exclusive mandate generation.",
      ],
      block2Roman: "II.",
      block2Title: "Strategic M&A Advisory",
      block2Body:
        "We manage the entire transaction lifecycle, from initial target identification to the final close. Our focus is the middle market, where we identify assets that align with international institutional mandates. We navigate the cultural and regulatory complexities of the Brazilian emergent market to ensure seamless execution.",
      block2Items: [
        "Off market origination protocols.",
        "Cross border due diligence.",
        "Sell side and buy side mandates.",
        "Closing room execution.",
      ],
      block3Roman: "III.",
      block3Title: "Intelligence & Roadshows",
      block3Body:
        "We bridge the information gap. Our proprietary market analysis identifies shifts before they become trends, providing our partners with a distinct competitive advantage. We also manage international roadshows, connecting high-growth assets with qualified venture capital and private equity firms globally.",
      block3Items: [
        "Proprietary intelligence dossiers.",
        "Tier one investor introductions.",
        "Curated international roadshows.",
        "Capital syndication support.",
      ],
      ctaTitle: "Engage the | institutional standard.",
      ctaBody:
        "From thesis architecture to closing room execution. We operate as your principal advisor on the ground.",
      ctaBtn: "Connect with Leadership",
    },
    sectors: {
      eyebrow: "Sectors of National Magnitude",
      title:
        "Brazil. One of the world's leading commercial powers in | agribusiness, energy, oil, and mineral resources.",
      subtitle:
        "Six pillars of national scale. Six gateways for institutional capital.",

      s1Title: "Private Healthcare",
      s1Stat: "Largest market in Latin America",
      s1Body:
        "Brazil hosts the largest private healthcare market in Latin America. An aging population, a growing middle class, and a fragmented hospital landscape create exceptional consolidation opportunities for institutional capital.",
      s1Items: [
        "Private hospital networks",
        "Diagnostic imaging and laboratories",
        "Health insurance operators",
        "Dental management organizations",
        "Biotech and pharmaceuticals",
        "HealthTech and telemedicine",
      ],

      s2Title: "Agribusiness",
      s2Stat: "World's largest exporter of beef and chicken",
      s2Body:
        "Brazil is the world's largest exporter of beef and chicken. Vast pasture land, low production costs, and strong sanitary controls make protein a defining national strength.",
      s2Items: [
        "Cattle and beef processing",
        "Poultry and pork operations",
        "Cold chain and logistics",
        "Slaughterhouses and packaging",
        "AgTech and farm management",
        "Animal nutrition and feed",
      ],

      s3Title: "Oil & Gas",
      s3Stat: "Among the top 10 producers globally",
      s3Body:
        "Brazil ranks among the top 10 oil producers in the world. Pre-salt discoveries and a maturing regulatory framework have opened the upstream and midstream chain to international participation.",
      s3Items: [
        "Pre-salt exploration and production",
        "Offshore platforms and FPSOs",
        "Refining and petrochemicals",
        "Pipelines and midstream",
        "LNG and natural gas",
        "Oilfield services",
      ],

      s4Title: "Mining",
      s4Stat: "World's second-largest exporter of iron ore",
      s4Body:
        "Brazil is the world's second-largest exporter of iron ore. The country also holds vast reserves of niobium, lithium, copper, and rare earths critical to the global energy transition.",
      s4Items: [
        "Iron ore and pellets",
        "Niobium, lithium, copper",
        "Rare earth elements",
        "Bauxite and aluminum",
        "Gold and precious metals",
        "Mineral logistics and ports",
      ],

      s5Title: "Clean Energy",
      s5Stat: "Global leader in renewables and biofuels",
      s5Body:
        "Brazil is a global leader in clean energy. More than 80 percent of national electricity comes from renewable sources, supported by hydro, wind, solar, and the world's most advanced biofuel program.",
      s5Items: [
        "Solar generation",
        "Wind farms, onshore and offshore",
        "Hydroelectric assets",
        "Ethanol and sugar cane",
        "Biomass and biogas",
        "Green hydrogen",
      ],

      s6Title: "Commodities",
      s6Stat: "World's largest exporter of soybeans and coffee",
      s6Body:
        "Brazil is the world's largest exporter of soybeans and coffee. The country also leads global trade in sugar, orange juice, and other strategic crops feeding food security worldwide.",
      s6Items: [
        "Soybean cultivation and crush",
        "Coffee plantations and processing",
        "Sugar and ethanol mills",
        "Orange juice and citrus",
        "Cotton and natural fibers",
        "Grain storage and export ports",
      ],

      expand: "Open sub-areas",
      collapse: "Close",

      ctaTitle: "Identify the asset | before the market does.",
      ctaBtn: "Strategic Consultation",
    },
    about: {
      eyebrow: "About Us",
      title: "Where Opportunity Meets | Global Capital.",
      subtitle:
        "Nivne Consulting Group connects high-potential companies to global capital. Our mission is clear: turn opportunity into international relevance by bringing the right businesses together with the right investors, at the right time, with the right strategy.",
      missionLabel: "Mission",
      mission:
        "To provide international investors with the Strategic Intelligence required to deploy capital securely across the Brazilian middle market.",
      visionLabel: "Vision",
      vision:
        "To be the definitive global reference for institutional entry into the Brazilian emergent market.",
      valuesEyebrow: "Values",
      valuesTitle: "Our Foundational | Principles",
      v1Title: "Institutional Excellence",
      v1Body:
        "We maintain the highest standards of technical precision in every valuation and strategic thesis we architect.",
      v2Title: "Strategic Stewardship",
      v2Body:
        "We approach every mandate with profound care, ensuring a commitment to long-term reliability and asset protection.",
      v3Title: "Synergetic Growth",
      v3Body:
        "We believe in building together. By aligning our local intelligence with global mandates, we ensure collective success.",
      diffEyebrow: "Value Proposition",
      diffTitle: "What Sets Nivne | Apart.",
      diffSub:
        "Strategic Intelligence meets global connectivity to drive middle market excellence.",

      vp1Title: "Proprietary Intelligence & Access",
      vp1Sub: "Informed Connectivity.",
      vp1Body:
        "We merge institutional grade analytical rigor with an exclusive, vetted network to unlock middle market opportunities that remain invisible to the broader market.",
      vp2Title: "Execution Driven Approach",
      vp2Sub: "Active Deal Management.",
      vp2Body:
        "We move beyond theory, actively driving the transaction lifecycle from initial narrative development to final investor engagement and deal closure.",
      vp3Title: "Investor Led Perspective",
      vp3Sub: "Institutional First Lens.",
      vp3Body:
        "Everything we build is engineered through the eyes of the decision maker, aligning opportunities with the specific risk, alpha, and timing metrics of global capital.",
      vp4Title: "Strategic Positioning",
      vp4Sub: "Engineered Presence.",
      vp4Body:
        "We design compelling investment narratives and structured opportunities that command attention and stand out in crowded, competitive global markets.",

      d1Title: "The 20 Year Benchmark",
      d1Body:
        "A legacy of precision in project controls and cost estimating.",
      d2Title: "Proven Scale",
      d2Body:
        "Directly involved in M&A transactions exceeding 500 million Reais.",
      d3Title: "Multidisciplinary Mastery",
      d3Body:
        "A unique synthesis of engineering logic and MBA-level strategy.",
      leadEyebrow: "Leadership",
      lead1Title: "The Architecture of Capital Readiness.",
      lead1Body:
        "At Nivne Consulting Group, leadership is the Strategic Stewardship of asset integrity. We do not merely advise. We architect the structural certainty required for global institutional deployment, ensuring that every asset is prepared for the complexities of the international market.",

      lead2Title: "The Standard of Strategic Excellence.",
      lead2Body:
        "Our leadership is defined by a consistent history of precision and high stakes performance. Having been a central architect in transactions and corporate restructurings exceeding 200 million Reais, we provide the battle tested insight necessary to navigate the Brazilian middle market. We focus on the fundamental health of the corporate vehicle, structuring assets to withstand the rigorous due diligence of global investors.",

      lead3Title: "Executive Portfolio Oversight.",
      lead3Body:
        "With a track record of providing direct advisory to the decision makers of more than 20 companies, our leadership serves as an executive extension for international funds. We specialize in removing the structural friction common in emergent markets, delivering assets that are transparent, governed, and primed for liquidity.",

      pillar1Title: "Sovereign Governance",
      pillar1Body:
        "We architect ironclad corporate frameworks that serve as a guarantee for institutional capital.",
      pillar2Title: "Strategic Asymmetry",
      pillar2Body:
        "We provide the refined intelligence and ground truth insights that standard market reports consistently overlook.",

      closeQuote:
        "In a landscape defined by volatility, our leadership provides the essential bridge between raw potential and institutional execution. We synthesize the certainty that makes the investment possible.",
      leadBody:
        "Our leadership represents the highest standard of corporate stewardship. With a background rooted in complex project management and high-level strategic advisory, our team speaks the language of global decision-makers. We are not just consultants: we are executive partners who have spent two decades managing cost, risk, and value for large-scale operations across the Americas.",
      ctaTitle: "Leverage two decades of precision for your | next deployment.",
      ctaBtn: "Connect with Leadership",
    },
    contact: {
      eyebrow: "Executive Connection",
      title: "Engage the | Strategic Intelligence.",
      body:
        "For institutional inquiries regarding the Brazilian middle market, connect directly with our leadership via the channels below. We operate under strict confidentiality and international compliance protocols.",
      formEyebrow: "Begin the Mandate",
      formTitle: "Initiate a | private consultation.",
      f_personal: "Personal Details",
      f_company: "Company Information",
      f_intent: "Reason for Contact",
      f_fullName: "Full Name",
      f_fullNamePh: "John Smith",
      f_email: "Email Address",
      f_emailPh: "john@company.com",
      f_phone: "Phone Number",
      f_phonePh: "(+1) 000 000 0000",
      f_companyName: "Company Name",
      f_companyPh: "Company / Organization",
      f_reasonPh:
        "Briefly describe your objective, current situation, or what you are looking to achieve.",
      f_submit: "Submit Request",
      f_response: "We typically respond within 24 to 48 hours.",
      f_required: "Required",
      f_invalid_email: "Provide a valid corporate email.",
      f_success_title: "Request received.",
      f_success_body:
        "Our leadership will review your inquiry under confidentiality protocols. Expect a direct reply within 24 to 48 hours.",
      f_error: "Submission failed. Please retry, or write to us directly.",
      directEyebrow: "Direct Channels",
      directTitle: "Reach the | principal desk.",
      emailLabel: "Email",
      linkedinLabel: "LinkedIn",
      locationsLabel: "Locations",
      locationsValue: "Los Angeles. Rio de Janeiro.",
      hoursLabel: "Operating Hours",
      hoursValue: "Mon to Fri. 08:00am to 17:00pm PST.",

      asideQuote:
        "We respond personally to every institutional inquiry, under strict confidentiality.",
      trust1Label: "Confidentiality",
      trust1Value: "Strict NDA Protocols",
      trust2Label: "Response Window",
      trust2Value: "24 to 48 Hours",
      trust3Label: "Compliance",
      trust3Value: "Cross Border Standard",
      trust4Label: "Coverage",
      trust4Value: "Los Angeles. Rio.",
    },
    footer: {
      tag: "One Step Ahead. Expertise You Can Trust.",
      sitemap: "Sitemap",
      legal: "",
      copy: "© 2026 Nivne Consulting Group. All rights reserved.",
    },
  },

  pt: {
    nav: {
      home: "Início",
      capabilities: "Soluções",
      sectors: "Setores",
      about: "Sobre Nós",
      contact: "Contato",
      cta: "Iniciar Consultoria",
    },
    common: {
      lang: "PT",
      explore: "Explorar",
      readMore: "Continuar",
      back: "Retornar",
      since: "Referência Estabelecida : Duas Décadas",
      locations: "Los Angeles. Rio de Janeiro.",
    },
    home: {
      eyebrow: "Expertise Estratégica. Precisão Institucional.",
      heroTitle: "Expertise Estratégica no | Middle Market Brasileiro.",
      heroSub:
        "Eliminando atritos. Assegurando valuation. Executando a entrada.",
      heroCta: "Consultoria Estratégica",
      heroSecondary: "Ver Soluções",

      quoteText:
        "Compreendemos tanto a realidade operacional dos negócios sul americanos quanto as expectativas dos investidores institucionais norte americanos.",

      // Slides do carrossel
      slide1Eyebrow: "Expertise Estratégica. Precisão Institucional.",
      slide1Title:
        "Expertise Estratégica no | Middle Market Brasileiro.",
      slide1Sub:
        "Originação direta e exclusiva nas maiores oportunidades do middle market brasileiro.",

      slide3Eyebrow: "A Ponte. Capital e Energia.",
      slide3Title: "Onde o Capital Global Encontra a | Energia Brasileira.",
      slide3Sub:
        "A Nivne desbloqueia os ativos mais valiosos do Brasil antes que cheguem ao mercado.",

      slide4Eyebrow: "Originador. Articulador. Assessoria Institucional.",
      slide4Title: "Não Esperamos Pelos Negócios. || Nós os Construímos.",
      slide4Sub:
        "Onde o capital institucional encontra quem realmente origina a oportunidade.",
      slide4CtaPrimary: "Consultoria Estratégica",
      slide4CtaSecondary: "Nossa Abordagem",

      slide5Eyebrow: "Óleo & Gás. Mineração. Agronegócio. Commodities.",
      slide5Title: "O Brasil é Profundo. || Nosso Acesso Também.",
      slide5Sub:
        "Das bacias do pré sal aos celeiros do agronegócio. Toda a profundidade de recursos do Brasil, originada por nós.",
      slide5CtaPrimary: "Explorar Setores",
      slide5CtaSecondary: "Ativos Reais",

      slide6Eyebrow: "Energia Limpa. Renováveis. Infraestrutura.",
      slide6Title: "O Futuro Está Sendo Construído. | Sabemos Exatamente Onde.",
      slide6Sub:
        "Solar, eólica, hidrogênio verde. A matriz energética da América Latina está sendo reescrita.",
      slide6SubItalic: "Já estamos à mesa.",
      slide6CtaPrimary: "Transição Energética",
      slide6CtaSecondary: "Nossos Mandatos",
      stripStat1Value: "500M+",
      stripStat1Label: "Reais em Exposição Direta de M&A",
      stripStat2Value: "20",
      stripStat2Label: "Anos de Referência Técnica",
      stripStat3Value: "Middle",
      stripStat3Label: "Market como Especialidade",
      stripStat4Value: "LA. Rio.",
      stripStat4Label: "Cobertura Operacional",

      solutionsEyebrow: "Soluções Estratégicas",
      solutionsTitle:
        "Arquitetamos o caminho para o | capital internacional.",
      solutionsBody:
        "Nossa abordagem é puramente técnica, eliminando a incerteza da implantação cross border no mercado emergente brasileiro.",

      f1Title: "Originação de Negócios",
      f1Body:
        "A originadora primária de deal flow exclusivo e off market no middle market brasileiro.",
      f2Title: "Assessoria de M&A",
      f2Body:
        "Identificação e proteção de alvos off market com precisão. Conduzimos o ciclo desde a originação até o fechamento.",
      f3Title: "Estratégia de Entrada",
      f3Body:
        "Roteiros sob medida para presença institucional sustentável. Desenhados sobre a realidade regulatória e operacional.",

      whyEyebrow: "Excelência no Detalhe",
      whyTitle: "Uma amostra da | nossa diferença.",
      why1Title: "Autoridade na Originação",
      why1Body:
        "Mandatos que nunca chegam a um leilão público. Nossa rede de operadores, family offices e fundadores Tier 1 traz oportunidades de middle market à mesa antes do restante do mercado saber que existem.",
      why2Title: "Acesso à Federação de Indústrias",
      why2Body:
        "Relacionamento direto com a segunda maior federação de indústrias do Brasil. Visibilidade sobre milhares de ativos operacionais em setores regulados. Onde outros enxergam ruído, lemos o sinal.",
      why3Title: "Análise Multidisciplinar",
      why3Body:
        "Cada transação é lida sob as lentes jurídica, financeira, regulatória e operacional ao mesmo tempo. O capital cross border merece mais do que uma tese de uma única disciplina. Exige triangulação institucional.",
      whyQuote:
        "Em private equity, o negócio se vence antes da assinatura do term sheet.",

      ctaEyebrow: "Engajamento Executivo",
      ctaTitle:
        "Faça parceria com a referência definitiva do | middle market brasileiro.",
      ctaButton: "Consultoria Estratégica",
    },
    capabilities: {
      eyebrow: "Valor técnico profundo. Originação absoluta.",
      title:
        "A Vantagem | Estratégica",
      subtitle:
        "Três mandatos integrados, uma única disciplina institucional. A porta de entrada definitiva para o middle market brasileiro.",
      block1Roman: "I.",
      block1Title: "Originação Proprietária de Negócios",
      block1Body:
        "A fonte definitiva de alpha off market. Atuamos como originadores primários para mandatos institucionais, utilizando um Ground Truth profundo para identificar ativos antes que cheguem ao mercado aberto. Nossos protocolos priorizam o fluxo exclusivo de negócios, garantindo que nossos parceiros contornem o atrito da corretagem tradicional e assegurem pontos de entrada de alto valor.",
      block1Items: [
        "Protocolos de originação off market.",
        "Sourcing proprietário de deal flow.",
        "Engajamento direto com fundadores.",
        "Geração de mandatos exclusivos.",
      ],
      block2Roman: "II.",
      block2Title: "Assessoria Estratégica de M&A",
      block2Body:
        "Conduzimos o ciclo completo da transação, desde a identificação do alvo até o fechamento. Nosso foco é o middle market, onde identificamos ativos alinhados aos mandatos institucionais internacionais. Navegamos as complexidades culturais e regulatórias do mercado emergente brasileiro para garantir uma execução sem ruído.",
      block2Items: [
        "Protocolos de originação off market.",
        "Due diligence cross border.",
        "Mandatos sell side e buy side.",
        "Execução em closing room.",
      ],
      block3Roman: "III.",
      block3Title: "Inteligência & Roadshows",
      block3Body:
        "Fechamos a lacuna de informação. Nossa análise proprietária identifica movimentos antes que se tornem tendência, oferecendo aos parceiros uma vantagem competitiva nítida. Conduzimos roadshows internacionais conectando ativos de alto crescimento a venture capital e private equity globais.",
      block3Items: [
        "Dossiês proprietários de inteligência.",
        "Apresentações a investidores Tier 1.",
        "Roadshows internacionais curados.",
        "Suporte a sindicalização de capital.",
      ],
      ctaTitle: "Engaje o | padrão institucional.",
      ctaBody:
        "Da arquitetura da tese à execução em closing room. Atuamos como seu assessor principal em campo.",
      ctaBtn: "Conectar com a Liderança",
    },
    sectors: {
      eyebrow: "Setores de Magnitude Nacional",
      title:
        "Brasil. Uma das maiores potências comerciais do mundo em | agronegócio, energia, petróleo e recursos minerais.",
      subtitle:
        "Seis pilares de escala nacional. Seis portas para o capital institucional.",

      s1Title: "Saúde Privada",
      s1Stat: "Maior mercado da América Latina",
      s1Body:
        "O Brasil tem o maior mercado de saúde privada da América Latina. Envelhecimento populacional, classe média em expansão e um cenário hospitalar fragmentado criam oportunidades excepcionais de consolidação para o capital institucional.",
      s1Items: [
        "Redes hospitalares privadas",
        "Diagnóstico por imagem e laboratórios",
        "Operadoras de planos de saúde",
        "Organizações de gestão odontológica",
        "Biotecnologia e farmacêuticos",
        "HealthTech e telemedicina",
      ],

      s2Title: "Agronegócio",
      s2Stat: "Maior exportador mundial de carne bovina e frango",
      s2Body:
        "O Brasil é o maior exportador mundial de carne bovina e frango. Vasta área de pastagem, custos competitivos e fortes controles sanitários fazem da proteína uma força nacional decisiva.",
      s2Items: [
        "Pecuária e processamento bovino",
        "Operações de aves e suínos",
        "Cadeia fria e logística",
        "Frigoríficos e embalagem",
        "AgTech e gestão de fazendas",
        "Nutrição animal e ração",
      ],

      s3Title: "Petróleo & Gás",
      s3Stat: "Entre os 10 maiores produtores globais",
      s3Body:
        "O Brasil está entre os 10 maiores produtores de petróleo do mundo. As descobertas do pré sal e um marco regulatório maduro abriram a cadeia upstream e midstream à participação internacional.",
      s3Items: [
        "Exploração e produção do pré sal",
        "Plataformas offshore e FPSOs",
        "Refino e petroquímica",
        "Dutos e midstream",
        "GNL e gás natural",
        "Serviços de campo",
      ],

      s4Title: "Mineração",
      s4Stat: "Segundo maior exportador mundial de minério de ferro",
      s4Body:
        "O Brasil é o segundo maior exportador mundial de minério de ferro. O país também detém vastas reservas de nióbio, lítio, cobre e terras raras, críticas para a transição energética global.",
      s4Items: [
        "Minério de ferro e pelotas",
        "Nióbio, lítio, cobre",
        "Terras raras",
        "Bauxita e alumínio",
        "Ouro e metais preciosos",
        "Logística mineral e portos",
      ],

      s5Title: "Energia Limpa",
      s5Stat: "Liderança global em renováveis e biocombustíveis",
      s5Body:
        "O Brasil é uma referência global em energia limpa. Mais de 80 por cento da eletricidade nacional vem de fontes renováveis, sustentada por hidrelétricas, eólica, solar e o programa de biocombustíveis mais avançado do mundo.",
      s5Items: [
        "Geração solar",
        "Parques eólicos onshore e offshore",
        "Ativos hidrelétricos",
        "Etanol e cana de açúcar",
        "Biomassa e biogás",
        "Hidrogênio verde",
      ],

      s6Title: "Commodities",
      s6Stat: "Maior exportador mundial de soja e café",
      s6Body:
        "O Brasil é o maior exportador mundial de soja e café. O país também lidera o comércio global de açúcar, suco de laranja e outras culturas estratégicas que sustentam a segurança alimentar mundial.",
      s6Items: [
        "Cultivo e esmagamento de soja",
        "Plantios e beneficiamento de café",
        "Usinas de açúcar e etanol",
        "Suco de laranja e citros",
        "Algodão e fibras naturais",
        "Armazenagem e portos de exportação",
      ],

      expand: "Abrir subáreas",
      collapse: "Fechar",

      ctaTitle: "Identifique o ativo | antes do mercado.",
      ctaBtn: "Consultoria Estratégica",
    },
    about: {
      eyebrow: "Sobre Nós",
      title: "Onde a Oportunidade Encontra o | Capital Global.",
      subtitle:
        "A Nivne Consulting Group conecta empresas de alto potencial ao capital global. Nossa missão é clara: transformar oportunidade em relevância internacional, unindo os negócios certos aos investidores certos, no momento certo, com a estratégia certa.",
      missionLabel: "Missão",
      mission:
        "Oferecer aos investidores internacionais a Inteligência Estratégica necessária para implantar capital com segurança no middle market brasileiro.",
      visionLabel: "Visão",
      vision:
        "Ser a referência global definitiva para a entrada institucional no mercado emergente brasileiro.",
      valuesEyebrow: "Valores",
      valuesTitle: "Nossos Princípios | Fundamentais",
      v1Title: "Excelência Institucional",
      v1Body:
        "Mantemos os mais altos padrões de precisão técnica em cada valuation e tese estratégica que arquitetamos.",
      v2Title: "Stewardship Estratégico",
      v2Body:
        "Tratamos cada mandato com profundo cuidado, garantindo confiabilidade de longo prazo e proteção do ativo.",
      v3Title: "Crescimento Sinérgico",
      v3Body:
        "Acreditamos em construir juntos. Ao alinhar nossa inteligência local aos mandatos globais, asseguramos sucesso coletivo.",
      diffEyebrow: "Proposta de Valor",
      diffTitle: "O Que Diferencia a | Nivne.",
      diffSub:
        "A Inteligência Estratégica encontra a conectividade global para impulsionar a excelência no middle market.",

      vp1Title: "Inteligência & Acesso Proprietários",
      vp1Sub: "Conectividade Informada.",
      vp1Body:
        "Combinamos rigor analítico de padrão institucional a uma rede exclusiva e validada, abrindo oportunidades de middle market invisíveis para o mercado em geral.",
      vp2Title: "Abordagem Orientada à Execução",
      vp2Sub: "Gestão Ativa do Deal.",
      vp2Body:
        "Vamos além da teoria, conduzindo ativamente todo o ciclo da transação, da construção da narrativa inicial ao engajamento final do investidor e ao fechamento.",
      vp3Title: "Visão de Investidor",
      vp3Sub: "Lente Institucional.",
      vp3Body:
        "Tudo que construímos é desenhado sob o olhar do decisor, alinhando oportunidades às métricas específicas de risco, alpha e timing do capital global.",
      vp4Title: "Posicionamento Estratégico",
      vp4Sub: "Presença Engenheirada.",
      vp4Body:
        "Desenhamos narrativas de investimento e estruturas de oportunidade que comandam atenção e se destacam em mercados globais saturados e competitivos.",

      d1Title: "A Referência de 20 Anos",
      d1Body:
        "Um legado de precisão em controles de projeto e estimativa de custos.",
      d2Title: "Escala Comprovada",
      d2Body:
        "Envolvimento direto em transações de M&A superiores a 500 milhões de Reais.",
      d3Title: "Maestria Multidisciplinar",
      d3Body:
        "Uma síntese única de lógica de engenharia e estratégia em nível MBA.",
      leadEyebrow: "Liderança",
      lead1Title: "A Arquitetura do Capital Readiness.",
      lead1Body:
        "Na Nivne Consulting Group, liderança é o Stewardship Estratégico da integridade do ativo. Não nos limitamos a aconselhar. Arquitetamos a certeza estrutural exigida para a implantação institucional global, garantindo que cada ativo esteja preparado para as complexidades do mercado internacional.",

      lead2Title: "O Padrão de Excelência Estratégica.",
      lead2Body:
        "Nossa liderança é definida por um histórico consistente de precisão e performance em alto risco. Tendo atuado como arquiteto central em transações e reestruturações corporativas superiores a 200 milhões de Reais, oferecemos a leitura testada em campo necessária para navegar o middle market brasileiro. Concentramos no estado fundamental do veículo societário, estruturando ativos para suportar a due diligence rigorosa de investidores globais.",

      lead3Title: "Supervisão Executiva de Portfólio.",
      lead3Body:
        "Com histórico de assessoria direta a decisores de mais de 20 empresas, nossa liderança atua como extensão executiva de fundos internacionais. Somos especialistas em remover o atrito estrutural comum em mercados emergentes, entregando ativos transparentes, governados e prontos para liquidez.",

      pillar1Title: "Governança Soberana",
      pillar1Body:
        "Arquitetamos estruturas corporativas blindadas que servem de garantia para o capital institucional.",
      pillar2Title: "Assimetria Estratégica",
      pillar2Body:
        "Entregamos a inteligência refinada e os insights de campo que relatórios convencionais consistentemente deixam passar.",

      closeQuote:
        "Em um cenário marcado pela volatilidade, nossa liderança constrói a ponte essencial entre o potencial bruto e a execução institucional. Sintetizamos a certeza que torna o investimento possível.",
      leadBody:
        "Nossa liderança representa o mais alto padrão de stewardship corporativo. Com origem em gestão complexa de projetos e assessoria estratégica de alto nível, nosso time fala a língua dos decisores globais. Não somos apenas consultores: somos parceiros executivos que passaram duas décadas gerindo custo, risco e valor em operações de larga escala nas Américas.",
      ctaTitle:
        "Acione duas décadas de precisão para a sua | próxima implantação.",
      ctaBtn: "Conectar com a Liderança",
    },
    contact: {
      eyebrow: "Conexão Executiva",
      title: "Engaje a | Inteligência Estratégica.",
      body:
        "Para consultas institucionais sobre o middle market brasileiro, conecte se diretamente com nossa liderança pelos canais abaixo. Operamos sob protocolos rígidos de confidencialidade e compliance internacional.",
      formEyebrow: "Iniciar o Mandato",
      formTitle: "Inicie uma | consultoria privada.",
      f_personal: "Dados Pessoais",
      f_company: "Informações da Empresa",
      f_intent: "Motivo do Contato",
      f_fullName: "Nome Completo",
      f_fullNamePh: "John Smith",
      f_email: "Endereço de E mail",
      f_emailPh: "john@company.com",
      f_phone: "Telefone",
      f_phonePh: "(+55) 00 00000 0000",
      f_companyName: "Empresa",
      f_companyPh: "Empresa / Organização",
      f_reasonPh:
        "Descreva brevemente seu objetivo, situação atual ou o que você busca alcançar.",
      f_submit: "Enviar Solicitação",
      f_response: "Costumamos responder em 24 a 48 horas.",
      f_required: "Obrigatório",
      f_invalid_email: "Informe um e mail corporativo válido.",
      f_success_title: "Solicitação recebida.",
      f_success_body:
        "Nossa liderança avaliará sua consulta sob protocolo de confidencialidade. Espere uma resposta direta em 24 a 48 horas.",
      f_error:
        "Falha no envio. Por favor tente novamente ou nos escreva diretamente.",
      directEyebrow: "Canais Diretos",
      directTitle: "Acesse a | mesa principal.",
      emailLabel: "E mail",
      linkedinLabel: "LinkedIn",
      locationsLabel: "Localizações",
      locationsValue: "Los Angeles. Rio de Janeiro.",
      hoursLabel: "Horário Operacional",
      hoursValue: "Seg a Sex. 08:00 às 17:00 PST.",

      asideQuote:
        "Respondemos pessoalmente a cada consulta institucional, sob confidencialidade rigorosa.",
      trust1Label: "Confidencialidade",
      trust1Value: "Protocolos NDA Rígidos",
      trust2Label: "Janela de Resposta",
      trust2Value: "24 a 48 Horas",
      trust3Label: "Compliance",
      trust3Value: "Padrão Cross Border",
      trust4Label: "Cobertura",
      trust4Value: "Los Angeles. Rio.",
    },
    footer: {
      tag: "One Step Ahead. Expertise You Can Trust.",
      sitemap: "Mapa do Site",
      legal: "",
      copy: "© 2026 Nivne Consulting Group. Todos os direitos reservados.",
    },
  },
};

export const DEFAULT_LOCALE = "en";
